import CopyItem from "../../../../global/new/CopyItem/CopyItem";
import ColoredChanges from "../ColoredChanges/ColoredChanges";
import { IMinerTypeCellProps } from "./MinerTypeCell.props";
import { getDevivedHash } from "@utils/hash.utils";
import { ALGOS_E } from "@constants/Algos";
import { useMinerContext } from "../MinerContext";

export default function MinerTypeCell(props: IMinerTypeCellProps) {
  const { style, className, copyClassName } = props;
  const { miner } = useMinerContext();

  return (
    <CopyItem
      className={className}
      style={style}
      copyClassName={copyClassName}
      text={getDevivedHash(miner.profile?.performance, { unit: miner.hash })}
    >
      <ColoredChanges>
        {getDevivedHash(miner.profile?.performance, { unit: "" as ALGOS_E })}
      </ColoredChanges>
    </CopyItem>
  );
}
